import { render, staticRenderFns } from "./PrimaryCategoryFilter.vue?vue&type=template&id=4c238dce"
import script from "./PrimaryCategoryFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimaryCategoryFilter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports